export const escapeHtml = (v) => String(v || '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#39;');

/** "3rd September 2026" — returns 'Not set' for an unparseable date. */
export const formatOrdinalDate = (dateValue) => {
  const d = new Date(dateValue);
  if (Number.isNaN(d.getTime())) return 'Not set';
  const months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  const n = d.getDate();
  const suffix = n % 10 === 1 && n !== 11 ? 'st' : n % 10 === 2 && n !== 12 ? 'nd' : n % 10 === 3 && n !== 13 ? 'rd' : 'th';
  return `${n}${suffix} ${months[d.getMonth()]} ${d.getFullYear()}`;
};

/** "Monday 3rd September 2026". Expects a date-only string (YYYY-MM-DD). */
export const fmtDate = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr + 'T00:00:00');
  if (isNaN(d)) return dateStr;
  const days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  const months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  const n = d.getDate();
  const suffix = n % 10 === 1 && n !== 11 ? 'st' : n % 10 === 2 && n !== 12 ? 'nd' : n % 10 === 3 && n !== 13 ? 'rd' : 'th';
  return `${days[d.getDay()]} ${n}${suffix} ${months[d.getMonth()]} ${d.getFullYear()}`;
};

/* Enum -> display label. Each falls back to the raw value so an unknown
   value from the API still renders rather than showing blank. */
export const fmtLabel = (f) => ({ singles: 'Singles', pairs: 'Pairs', triples: 'Triples', fours: 'Fours', '2-4-2-pairs': '2-4-2 Pairs', custom: 'Custom' }[f] || f);
export const mtLabel = (mt) => ({ ends: 'Set Ends', 'first-to': 'First To', timed: 'Timed', sets: 'Sets Play' }[mt] || mt);
export const ttLabel = (tt) => ({ 'round-robin': 'Round Robin', knockout: 'Knockout', 'double-elimination': 'Double Elimination', swiss: 'Swiss' }[tt] || tt);

/** "14:30" -> "2:30pm". Returns the input unchanged if it will not parse. */
export const fmtTime12 = (t) => {
  if (!t) return '';
  const [h, m] = t.split(':').map(Number);
  if (isNaN(h)) return t;
  const hr = h % 12 || 12;
  const ampm = h < 12 ? 'am' : 'pm';
  return `${hr}:${String(m).padStart(2, '0')}${ampm}`;
};

/* A stored date as a date box wants it: 'YYYY-MM-DD', or '' for none.
   Read in local time, not via toISOString — that is UTC, and in New Zealand
   a date saved at midday would come back as the day before. */
export const toDateInputValue = (value) => {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  const pad = n => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};
